import { gql, useMutation } from '@apollo/client';
import {
  Box,
  Button,
  Modal,
  ModalClose,
  ModalDialog,
  Typography,
} from '@mui/joy';
import { useCallback, useState } from 'react';
import { SubmitHandler } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { showMessage } from '../../store/snackbar-slice';

const deleteUserInviteMutation = gql`
  mutation DeleteUserInvite($_id: ID!) {
    deleteUserInvite(_id: $_id)
  }
`;

interface Props {
  visible: any;
  onFinish: () => void;
  onCancel: () => void;
}

function DeleteUserInviteModal({ visible, onFinish, onCancel }: Props) {
  const { userInvite } = visible || {};
  const [saving, setSaving] = useState(false);
  const [deleteUserInvite] = useMutation(deleteUserInviteMutation);

  const dispatch = useDispatch();
  const onSubmit: SubmitHandler<any> = useCallback(
    async (values) => {
      setSaving(true);
      try {
        await deleteUserInvite({
          variables: {
            _id: userInvite._id,
          },
        });
        dispatch(
          showMessage({
            _id: 'delete-user-invite',
            severity: 'success',
            message: 'Success',
          }),
        );
        onFinish();
      } catch (err: any) {
        console.error(err);
        dispatch(
          showMessage({
            _id: 'delete-user-invite',
            severity: 'danger',
            message: 'There was an error deleting your user invite',
          }),
        );
      }
      setSaving(false);
    },
    [deleteUserInvite, userInvite, onFinish, dispatch],
  );

  return (
    <>
      <Modal open={!!visible} onClose={onCancel}>
        <ModalDialog sx={{ p: 4, width: 400, maxWidth: '90uvw' }}>
          <ModalClose />
          <Typography level="h3" sx={{ mb: 2, textAlign: 'center' }}>
            Delete User Invite
          </Typography>
          <Typography sx={{ textAlign: 'center' }}>
            Are you sure you want to delete this user invite?
          </Typography>
          {userInvite && (
            <Box>
              <Typography sx={{ textAlign: 'center' }}>
                {userInvite.name}
              </Typography>
              <Typography sx={{ textAlign: 'center' }}>
                {userInvite.email}
              </Typography>
            </Box>
          )}
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
            <Button
              variant="outlined"
              color="neutral"
              disabled={saving}
              size="lg"
              onClick={onCancel}
              sx={{ mr: 4, width: 100 }}
            >
              Cancel
            </Button>
            <Button
              onClick={onSubmit}
              loading={saving}
              variant="solid"
              size="lg"
              sx={{ width: 100 }}
            >
              Delete
            </Button>
          </Box>
        </ModalDialog>
      </Modal>
    </>
  );
}

export default DeleteUserInviteModal;
